
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals=document.querySelectorAll('.nli-reveal');
  if(!reduce&&'IntersectionObserver'in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target);}
      });
    },{threshold:.12});
    reveals.forEach(function(el){io.observe(el);});
  }else{reveals.forEach(function(el){el.classList.add('is-visible');});}
  if(reduce)return;
  document.querySelectorAll('[data-nli-scene]').forEach(function(scene){
    var moving=scene.querySelectorAll('[data-depth]');
    scene.addEventListener('pointermove',function(e){
      var r=scene.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
      moving.forEach(function(el){var d=parseFloat(el.dataset.depth||'1');el.style.translate=(x*d*20)+'px '+(y*d*16)+'px';});
    });
    scene.addEventListener('pointerleave',function(){moving.forEach(function(el){el.style.translate='0 0';});});
  });
  document.querySelectorAll('[data-tilt]').forEach(function(card){
    card.addEventListener('pointermove',function(e){
      var r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
      card.style.transform='perspective(900px) rotateX('+(-y*5)+'deg) rotateY('+(x*6)+'deg) translateY(-3px)';
    });
    card.addEventListener('pointerleave',function(){card.style.transform='';});
  });
})();
